import { createPortal } from 'react-dom';
import { useApp } from '../common/AppProvider';
import { useMobile } from './useMobileHook';
import { translations } from '../translations/translations';
import { ExIcon } from '@boomi/exosphere';
import AnimatedLink from '../common/AnimatedLink';

import './welcome.css';

const WelcomeBanner = () => {
    const { userInfo, language } = useApp();
    const { isMobile, portalContainer } = useMobile(800);

    const addNewTaskButton = () => (
        <AnimatedLink className="new-task-button exo-button-secondary" to="/tasks/new">
            <ExIcon
                className="new-task-icon"
                icon="plus"
                slot="prefix"
                hide-browser-tooltip
            ></ExIcon>
            <span className="new-task-text">{translations[language].TASKS_add_new}</span>
        </AnimatedLink>
    );

    return (
        <section className="automate-welcome">
            <div className="content-wrapper">
                <h2 className="welcome-title title xl-clamp">
                    {translations[language].WELCOME_title}
                    {userInfo && (
                        <span className="welcome-name">
                            , {(userInfo?.given_name as string) ?? ''}
                        </span>
                    )}
                    !
                </h2>

                <p className="welcome-text text md">{translations[language].WELCOME_text}</p>

                {/* Portal the button into the footer on mobile. This UI behaviour is experimental for now. */}
                {isMobile && portalContainer
                    ? createPortal(addNewTaskButton(), portalContainer)
                    : addNewTaskButton()}
            </div>
        </section>
    );
};

export default WelcomeBanner;
